// extracted by mini-css-extract-plugin
export default {"home__container":"Home_home__container__8kX4M","home__inner":"Home_home__inner__Zpaer"};